import SiteHeader from '@/pages/home/components/SiteHeader';
import Ticker from '@/pages/home/components/Ticker';
import HeroSpread from '@/pages/home/components/HeroSpread';
import BreakingFeed from '@/pages/home/components/BreakingFeed';
import NavEntries from '@/pages/home/components/NavEntries';
import FeaturedCollections from '@/pages/home/components/FeaturedCollections';
import PersonIndex from '@/pages/home/components/PersonIndex';
import EventTimeline from '@/pages/home/components/EventTimeline';
import CategorySection from '@/pages/home/components/CategorySection';
import ArchiveIndex from '@/pages/home/components/ArchiveIndex';
import DownloadBand from '@/pages/home/components/DownloadBand';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main className="w-full">
        <Ticker />
        <HeroSpread />
        <BreakingFeed />
        <NavEntries />
        <FeaturedCollections />
        <PersonIndex />
        <EventTimeline />
        <CategorySection />
        <ArchiveIndex />
        <DownloadBand />
      </main>
      <SiteFooter />
    </div>
  );
}